
const TabLoad = function (id, callback) {
    const $el = $(id);
    if ($el.length === 0) {
        return;
    }
    const loaded = $el.data('loaded');
    if($el.is(':visible') && !loaded) {
        $el.data('loaded', true);
        callback();
        return;
    }
    $el.on('activate', () => {
        if (!loaded) {
            $el.data('loaded', true);
            callback();
            $el.off('activate');
        }
    });
}

export default TabLoad;